export default __webpack_public_path__ + "static/media/time.ab04d8b6.svg";